module.exports = __webpack_public_path__ + "img/dc2aee6dfcf76e4c466a07d519ed3fc6.png";